var exports = {
  "Ng": "tipContainer__lBHqsL",
  "G": "tipLabel__QwEq4E",
  "xY": "tipText__Dg1bzm",
  "qG": "fadeIn__5N7AAC",
};

module.exports = exports;
